import {ServiceRequest} from "../utils/service-request"
import {
    MOTOR_CADASTRO_PATH,
    MOTOR_CADASTRO_TEMPORARIO_PATH
} from "../utils/api-routes"

class MotorParametrosService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async loadCadastrosParametros(cetip, versao) {
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versao) params.append("VersaoDocumento", versao)
        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_PATH}/parametros${query}`)
    }

    async getCadastroTemporarioParametros(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/parametros`
        return this.request.get(path)
    }

    
    async getCadastroParametros(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/parametros`
        return this.request.get(path)
    }


    async createCadastroTemporarioParametros(id, payload){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/parametros`
        return this.request.post(path, payload)
    }

    async createCadastroParametros(id, payload){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/parametros`
        return this.request.post(path, payload)
    }

    async updateCadastroParametros(id, payload){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/parametros`
        return this.request.patch(path, payload)
    }

    async deleteCadastroTemporarioParametros(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_TEMPORARIO_PATH}/${safeId}/parametros`
        return this.request.delete(path)
    }

    async deleteCadastroParametros(id){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/parametros`
        return this.request.delete(path)
    }

}

export default MotorParametrosService